<template>
    <div class="post-filter" v-click-outside="close">
        <div class="filter-section-search" v-if="!hideSearchBar">
            <div class="input">
                <div class="container-svg"><svg xmlns="http://www.w3.org/2000/svg" width="auto" height="auto" viewBox="0 0 21 21" fill="none"><path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#E3D2EE"></path></svg></div>
                <input :placeholder="$t('dash.posts.list.search')" v-model.lazy="models.search">
            </div>
        </div>

        <div class="filter-section-status">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.status') }} <span>({{ countStatusShow }})</span></p>
                <p class="reset" v-if="countStatusShow < 9" @click="addAllStatus">{{ $t('dash.posts.filter.show-all') }}</p>
                <p class="reset" v-else @click="removeAllStatus">{{ $t('dash.posts.filter.hide-all') }}</p>
            </div>
            <div class="list">
                <template v-for="name in ['scheduled','posted','draft','pending','failed','removed','standby', 'awaiting_approval', 'to_validate']">
                    <div class="badge-status" :status="name" :class="{disable: !filter.statusDisplay[name]}" @click="toggleStatus(name)">
                        {{ $t(`dash.post.${name}`) }}
                    </div>
                </template>
            </div>
        </div>

        <div class="filter-section-type">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.type') }} <span>({{ countTypesShow }})</span></p>
                <p class="reset" @click="addAllTypes" v-if="countTypesShow < 6">{{ $t('dash.posts.filter.show-all') }}</p>
                <p class="reset" @click="removeAllTypes" v-else>{{ $t('dash.posts.filter.hide-all') }}</p>
            </div>
            <div class="list">
                <template v-for="type in ['image','video','reel','story','carousel', 'document']">
                    <div class="type" :key="type">
                        <Checkbox :id="type" :prefixId="'filterPost'" :isChecked="filter.typesDisplay[type]" :remove="toggleType" :add="toggleType"/>
                        <label :for="`filterPost${type}`">{{ type }}</label>
                    </div>
                </template>
            </div>
        </div>

        <div class="filter-section-date" v-if="showDateRange">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.date') }}</p>
                <p class="reset" v-if="dateRange.startDate || dateRange.endDate" @click="clearDates">{{ $t('dash.posts.filter.show-all') }}</p>
            </div>
            <div class="container-dates">
                <div class="dates">
                    <input type="date" :value="dateRange.startDate" @input="setStartDate($event.target.value)">
                    {{ $t('dash.posts.filter.date-to') }}
                    <input type="date" :value="dateRange.endDate" @input="setEndDate($event.target.value)">
                </div>
            </div>
        </div>

        <!-- Multiselect créateurs -->
        <div class="filter-section-creator" v-if="allUsers.length" v-click-outside="closeCreatorDropdown">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.creator') }}<span v-if="selectedCreators.length"> ({{ selectedCreators.length }})</span></p>
                <p class="reset" v-if="selectedCreators.length" @click="clearCreators">{{ $t('dash.posts.filter.show-all') }}</p>
            </div>

            <!-- Trigger -->
            <div class="creator-select-trigger" :class="{ open: creatorDropdownOpen }" @click="toggleCreatorDropdown">
                <div class="creator-trigger-content">
                    <span v-if="!selectedCreators.length" class="creator-placeholder">{{ $t('dash.posts.filter.creator_all') }}</span>
                    <div v-else class="creator-tags">
                        <span class="creator-tag" v-for="user in displayedTags" :key="user.id">
                            <span class="tag-avatar" :style="user.avatar ? {} : { background: avatarColor(user) }">
                                <img v-if="user.avatar" :src="user.avatar" :alt="initials(user)">
                                <template v-else>{{ initials(user) }}</template>
                            </span>
                            <span class="tag-name">{{ user.firstname || user.email }}</span>
                            <button class="tag-remove" @click.stop="toggleCreator(user.id)">×</button>
                        </span>
                        <span v-if="extraTagsCount > 0" class="creator-tag creator-tag-more">+{{ extraTagsCount }}</span>
                    </div>
                </div>
                <svg class="creator-chevron" :class="{ rotated: creatorDropdownOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 4L6 8L10 4" stroke="#9ba3b7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <!-- Dropdown -->
            <div v-if="creatorDropdownOpen" class="creator-dropdown">
                <div class="creator-dropdown-search">
                    <svg width="13" height="13" viewBox="0 0 21 21" fill="none"><path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C14.4375 14.4375 14.4375 2.625 8.53125 2.625C2.625 2.625 2.625 14.4375 8.53125 14.4375Z" fill="#9ba3b7"/></svg>
                    <input
                        ref="creatorSearchInput"
                        type="text"
                        v-model="creatorSearch"
                        :placeholder="$t('dash.posts.filter.creator_search')"
                        @click.stop
                    >
                </div>
                <div class="creator-dropdown-list">
                    <div
                        v-if="!filteredCreators.length"
                        class="creator-no-result"
                    >{{ $t('dash.posts.filter.no_result') }}</div>
                    <div
                        v-for="user in filteredCreators"
                        :key="user.id"
                        class="creator-option"
                        :class="{ selected: isCreatorSelected(user.id) }"
                        @click.stop="toggleCreator(user.id)"
                    >
                        <span class="option-avatar" :style="user.avatar ? {} : { background: avatarColor(user) }">
                            <img v-if="user.avatar" :src="user.avatar" :alt="initials(user)">
                            <template v-else>{{ initials(user) }}</template>
                        </span>
                        <div class="option-info">
                            <div class="option-name-row">
                                <span class="option-name">{{ user.firstname }} {{ user.lastname }}</span>
                                <span class="creator-role-badge" :data-role="userRole(user)">{{ userRoleLabel(user) }}</span>
                            </div>
                            <span class="option-email">{{ user.email }}</span>
                        </div>
                        <svg v-if="isCreatorSelected(user.id)" class="option-check" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2.5 7L5.5 10L11.5 4" stroke="#6B1F4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span v-else class="option-check-placeholder"></span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Multiselect étiquettes -->
        <div class="filter-section-label" v-if="allLabelsList.length" v-click-outside="closeLabelDropdown">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.label') }}<span v-if="selectedLabels.length"> ({{ selectedLabels.length }})</span></p>
                <p class="reset" v-if="selectedLabels.length" @click="clearLabels">{{ $t('dash.posts.filter.show-all') }}</p>
            </div>

            <div class="label-select-trigger" :class="{ open: labelDropdownOpen }" @click="toggleLabelDropdown">
                <div class="label-trigger-content">
                    <span v-if="!selectedLabels.length" class="label-placeholder">{{ $t('dash.posts.filter.label_all') }}</span>
                    <div v-else class="label-tags">
                        <span class="label-tag" v-for="label in displayedLabelTags" :key="label.id">
                            <span class="tag-dot" :style="{ backgroundColor: label.color }">
                                <i v-if="parseIcon(label.icon) && parseIcon(label.icon).type === 'fa'" class="fa-solid" :class="`fa-${parseIcon(label.icon).value}`"></i>
                                <span v-else-if="parseIcon(label.icon)" class="dot-emoji">{{ parseIcon(label.icon).value }}</span>
                            </span>
                            <span class="tag-name">{{ label.name }}</span>
                            <button class="tag-remove" @click.stop="toggleLabel(label.id)">×</button>
                        </span>
                        <span v-if="extraLabelTagsCount > 0" class="label-tag label-tag-more">+{{ extraLabelTagsCount }}</span>
                    </div>
                </div>
                <svg class="label-chevron" :class="{ rotated: labelDropdownOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 4L6 8L10 4" stroke="#9ba3b7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div v-if="labelDropdownOpen" class="label-dropdown">
                <div class="label-dropdown-search">
                    <svg width="13" height="13" viewBox="0 0 21 21" fill="none"><path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C14.4375 14.4375 14.4375 2.625 8.53125 2.625C2.625 2.625 2.625 14.4375 8.53125 14.4375Z" fill="#9ba3b7"/></svg>
                    <input
                        ref="labelSearchInput"
                        type="text"
                        v-model="labelSearch"
                        :placeholder="$t('dash.posts.filter.label_search')"
                        @click.stop
                    >
                </div>
                <div class="label-dropdown-list">
                    <div
                        v-if="!filteredLabels.length"
                        class="label-no-result"
                    >{{ $t('dash.posts.filter.no_result') }}</div>
                    <div
                        v-for="label in filteredLabels"
                        :key="label.id"
                        class="label-option"
                        :class="{ selected: isLabelSelected(label.id) }"
                        @click.stop="toggleLabel(label.id)"
                    >
                        <span class="option-dot" :style="{ backgroundColor: label.color }">
                            <i v-if="parseIcon(label.icon) && parseIcon(label.icon).type === 'fa'" class="fa-solid" :class="`fa-${parseIcon(label.icon).value}`"></i>
                            <span v-else-if="parseIcon(label.icon)" class="dot-emoji">{{ parseIcon(label.icon).value }}</span>
                        </span>
                        <span class="option-name">{{ label.name }}</span>
                        <svg v-if="isLabelSelected(label.id)" class="option-check" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2.5 7L5.5 10L11.5 4" stroke="#6B1F4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span v-else class="option-check-placeholder"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from '@/components/dash/utils/checkbox.vue';
    import ClickOutside from 'vue-click-outside'
    import { parseLabelIcon } from '@/utils/labelIcon.js'

    const AVATAR_COLORS = ['#6B1F4D', '#1a73c9', '#1a8a3e', '#b07a1a', '#7c3aed', '#0891b2', '#be185d', '#0d7377']

    export default {
        components: { Checkbox },

        props: {
            filter: Object,
            hideSearchBar: { default: false, type: Boolean },
            showDateRange: { default: false, type: Boolean },
            pageIds: { type: Array, default: function() { return [] } }
        },

        directives: { ClickOutside },

        data() {
            return {
                models: { search: '' },
                allUsers: [],
                creatorSearch: '',
                creatorDropdownOpen: false,
                labelSearch: '',
                labelDropdownOpen: false,
            }
        },

        created() {
            this.$set(this.models, 'search', this.filter.search)
            this.loadUsers()
            // Always refresh (not just when empty) — otherwise labels created/edited
            // since the store was first populated this session never show up here.
            this.$store.dispatch('labels/init')
        },

        computed: {
            filteredCreators() {
                const pageIds = this.pageIds || []
                const q = this.creatorSearch.toLowerCase().trim()
                return this.allUsers.filter(u => {
                    if (u.admin) return true
                    if (!u.pages_access || u.pages_access.length === 0) return true
                    if (pageIds.length && !pageIds.some(id => u.pages_access.includes(id))) return false
                    return true
                }).filter(u => {
                    if (!q) return true
                    const name = ((u.firstname || '') + ' ' + (u.lastname || '')).toLowerCase()
                    const email = (u.email || '').toLowerCase()
                    return name.includes(q) || email.includes(q)
                })
            },
            selectedCreators() {
                const selected = (this.filter.creators || [])
                return this.allUsers.filter(u => selected.includes(String(u.id)))
            },
            displayedTags() {
                return this.selectedCreators.slice(0, 2)
            },
            extraTagsCount() {
                return Math.max(0, this.selectedCreators.length - 2)
            },
            countStatusShow() {
                return Object.values(this.filter.statusDisplay).filter(v => v === true).length
            },
            countTypesShow() {
                return Object.values(this.filter.typesDisplay).filter(v => v === true).length
            },
            dateRange() {
                return (this.filter.dateRange) || { startDate: null, endDate: null }
            },
            allLabelsList() {
                return this.$store.getters['labels/getLabelsList']
            },
            filteredLabels() {
                const q = this.labelSearch.toLowerCase().trim()
                if (!q) return this.allLabelsList
                return this.allLabelsList.filter(label => label.name.toLowerCase().includes(q))
            },
            selectedLabels() {
                const selected = (this.filter.labels || [])
                return this.allLabelsList.filter(label => selected.includes(label.id))
            },
            displayedLabelTags() {
                return this.selectedLabels.slice(0, 2)
            },
            extraLabelTagsCount() {
                return Math.max(0, this.selectedLabels.length - 2)
            }
        },

        methods: {
            parseIcon(icon) {
                return parseLabelIcon(icon)
            },
            close() {
                this.creatorDropdownOpen = false
                this.$emit('close')
            },
            toggleCreatorDropdown() {
                this.creatorDropdownOpen = !this.creatorDropdownOpen
                if (this.creatorDropdownOpen) {
                    this.$nextTick(() => {
                        if (this.$refs.creatorSearchInput) this.$refs.creatorSearchInput.focus()
                    })
                } else {
                    this.creatorSearch = ''
                }
            },
            closeCreatorDropdown() {
                if (this.creatorDropdownOpen) {
                    this.creatorDropdownOpen = false
                    this.creatorSearch = ''
                }
            },
            isCreatorSelected(id) {
                return !!(this.filter.creators && this.filter.creators.includes(id))
            },
            initials(user) {
                const f = (user.firstname || '').charAt(0).toUpperCase()
                const l = (user.lastname || '').charAt(0).toUpperCase()
                return f + l || (user.email || '?').charAt(0).toUpperCase()
            },
            avatarColor(user) {
                const code = ((user.firstname || '') + (user.lastname || '') + (user.id || '')).split('').reduce((acc, c) => acc + c.charCodeAt(0), 0)
                return AVATAR_COLORS[code % AVATAR_COLORS.length]
            },
            async loadUsers() {
                try {
                    const cached = localStorage.getItem('users')
                    if (cached) {
                        const parsed = JSON.parse(cached)
                        if (parsed && Array.isArray(parsed.users)) { this.allUsers = parsed.users; return }
                    }
                } catch(e) {}
                try {
                    const token = localStorage.getItem('token')
                    const host = process.env.VUE_APP_API_HOST
                    const res = await fetch(host + '/users', { headers: { Authorization: token ? 'Bearer ' + token : '' } })
                    if (!res.ok) return
                    const data = await res.json()
                    if (data && Array.isArray(data.users)) {
                        this.allUsers = data.users
                        localStorage.setItem('users', JSON.stringify({ users: data.users }))
                    }
                } catch(e) {}
            },
            userRole(user) {
                if (user.admin) return 'admin'
                if (!user.role || !user.role.length) return 'editor'
                return user.role[0].toLowerCase()
            },
            userRoleLabel(user) {
                const map = { admin: 'Admin', editor: 'Éditeur', writter: 'Rédacteur', writer: 'Rédacteur', viewer: 'Lecteur' }
                return map[this.userRole(user)] || this.userRole(user)
            },
            toggleCreator(id) {
                const sid = String(id)
                const creators = (this.filter.creators || []).map(String)
                const idx = creators.indexOf(sid)
                if (idx >= 0) creators.splice(idx, 1)
                else creators.push(sid)
                this.filter.creators = creators
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            clearCreators() {
                this.filter.creators = []
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            toggleStatus(name) {
                this.filter.statusDisplay[name] = !this.filter.statusDisplay[name]
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            toggleType(name) {
                this.filter.typesDisplay[name] = !this.filter.typesDisplay[name]
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            removeAllStatus() {
                for (const k in this.filter.statusDisplay) this.filter.statusDisplay[k] = false
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            addAllStatus() {
                for (const k in this.filter.statusDisplay) this.filter.statusDisplay[k] = true
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            addAllTypes() {
                for (const k in this.filter.typesDisplay) this.filter.typesDisplay[k] = true
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            removeAllTypes() {
                for (const k in this.filter.typesDisplay) this.filter.typesDisplay[k] = false
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            setStartDate(val) {
                if (!this.filter.dateRange) this.$set(this.filter, 'dateRange', { startDate: null, endDate: null })
                this.filter.dateRange.startDate = val || null
                this.$emit('update:filter', this.filter)
            },
            setEndDate(val) {
                if (!this.filter.dateRange) this.$set(this.filter, 'dateRange', { startDate: null, endDate: null })
                this.filter.dateRange.endDate = val || null
                this.$emit('update:filter', this.filter)
            },
            clearDates() {
                if (!this.filter.dateRange) return
                this.filter.dateRange.startDate = null
                this.filter.dateRange.endDate = null
                this.$emit('update:filter', this.filter)
            },
            toggleLabelDropdown() {
                this.labelDropdownOpen = !this.labelDropdownOpen
                if (this.labelDropdownOpen) {
                    this.$nextTick(() => {
                        if (this.$refs.labelSearchInput) this.$refs.labelSearchInput.focus()
                    })
                } else {
                    this.labelSearch = ''
                }
            },
            closeLabelDropdown() {
                if (this.labelDropdownOpen) {
                    this.labelDropdownOpen = false
                    this.labelSearch = ''
                }
            },
            isLabelSelected(id) {
                return !!(this.filter.labels && this.filter.labels.includes(id))
            },
            toggleLabel(id) {
                const labels = (this.filter.labels || []).slice()
                const idx = labels.indexOf(id)
                if (idx >= 0) labels.splice(idx, 1)
                else labels.push(id)
                this.filter.labels = labels
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            },
            clearLabels() {
                this.filter.labels = []
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            }
        },

        watch: {
            ['models.search'](newValue) {
                this.filter.search = this.models.search.trim().toLowerCase()
                this.$emit('update:filter', this.filter)
                this.$emit('updateCalendar')
            }
        },
    }
</script>

<style scoped>
/* ── Créateurs : trigger ───────────────────────────────── */
.filter-section-creator { margin-top: 14px; }

.creator-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 36px;
    padding: 6px 10px;
    border: 1px solid #E3D2EE;
    border-radius: 8px;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.15s;
    box-sizing: border-box;
}
.creator-select-trigger:hover,
.creator-select-trigger.open { border-color: #6B1F4D; }

.creator-trigger-content { display: flex; flex-wrap: wrap; gap: 5px; flex: 1; min-width: 0; }

.creator-placeholder { font-size: 12px; color: #9ba3b7; line-height: 24px; }

.creator-chevron { flex-shrink: 0; transition: transform 0.15s; }
.creator-chevron.rotated { transform: rotate(180deg); }

/* ── Tags (sélectionnés dans le trigger) ───────────────── */
.creator-tags { display: flex; flex-wrap: wrap; gap: 5px; }

.creator-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 22px;
    padding: 0 4px 0 3px;
    background: #f1edf5;
    border-radius: 5px;
    font-size: 11px;
    color: #6B1F4D;
    font-weight: 500;
    max-width: 120px;
}
.tag-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    overflow: hidden;
}
.tag-avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
.tag-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 68px;
}
.creator-tag .tag-remove {
    background: transparent !important;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 13px;
    line-height: 1;
    color: #6B1F4D !important;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    opacity: 0.5;
    transition: opacity 0.15s;
}
.creator-tag .tag-remove:hover { opacity: 1; background: transparent !important; }

/* ── Dropdown ──────────────────────────────────────────── */
.creator-dropdown {
    margin-top: 4px;
    border: 1px solid #E3D2EE;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    overflow: hidden;
}

.creator-dropdown-search {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 8px 10px;
    border-bottom: 1px solid #f0e8f6;
}
.creator-dropdown-search svg { flex-shrink: 0; opacity: 0.6; }
.creator-dropdown-search input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 12px;
    color: #121826;
    background: transparent;
}
.creator-dropdown-search input::placeholder { color: #9ba3b7; }

.creator-dropdown-list {
    max-height: 220px;
    overflow-y: auto;
    padding: 4px 0;
}
.creator-dropdown-list::-webkit-scrollbar { width: 4px; }
.creator-dropdown-list::-webkit-scrollbar-track { background: transparent; }
.creator-dropdown-list::-webkit-scrollbar-thumb { background: #E3D2EE; border-radius: 2px; }

.creator-no-result { padding: 12px 14px; font-size: 12px; color: #9ba3b7; text-align: center; }

/* ── Option ────────────────────────────────────────────── */
.creator-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 10px;
    cursor: pointer;
    transition: background 0.1s;
    line-height: 1;
}
.creator-option:hover { background: #faf6fc; }
.creator-option.selected { background: #f7f0fb; }

.option-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    overflow: hidden;
}
.option-avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }

.option-info { display: flex; flex-direction: column; align-items: flex-start; flex: 1; min-width: 0; gap: 2px; }
.option-name-row { display: flex; align-items: center; gap: 5px; }
.option-name { font-size: 12px; font-weight: 500; color: #121826; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1.2; }
.option-email { font-size: 10px; color: #9ba3b7; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1.2; align-self: flex-start; }

.option-check { flex-shrink: 0; }
.option-check-placeholder { width: 14px; flex-shrink: 0; }

/* ── Badge rôle ────────────────────────────────────────── */
.creator-role-badge {
    font-size: 9px;
    font-weight: 600;
    padding: 1px 4px;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    flex-shrink: 0;
    white-space: nowrap;
    line-height: 1.4;
}
.creator-role-badge[data-role="admin"]   { background: #f1edf5; color: #6B1F4D; }
.creator-role-badge[data-role="editor"]  { background: #e8f4fd; color: #1a73c9; }
.creator-role-badge[data-role="writter"],
.creator-role-badge[data-role="writer"] { background: #e8fde9; color: #1a8a3e; }
.creator-role-badge[data-role="viewer"]  { background: #fdf5e8; color: #b07a1a; }

/* ── Tag +N overflow ───────────────────────────────────── */
.creator-tag-more {
    background: #ede8f0;
    color: #6B1F4D;
    font-weight: 600;
    padding: 0 6px;
    cursor: default;
}
</style>
